import React from 'react';
import { Form, Input, Select, Upload, Switch } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { AccountMetaData } from '../../../../config/settings';
import { getUploadApiBaseUrl } from '../../../../lib/apis';

const { Option } = Select;

export default function ProductFormSection(props) {
    const { categories = [], fileList = [], onFileChange } = props;

    return (
        <div>
            <Form.Item name="title" label="Tên sản phẩm" rules={[{ required: true, message: 'Không được để trống tên sản phẩm' }]}>
                <Input />
            </Form.Item>
            <Form.Item name="category_id" label="Danh mục" rules={[{ required: true, message: 'Không được để trống danh mục' }]}>
                <Select placeholder="Chọn danh mục">
                    {categories.map((item) => <Option key={item._id} value={item._id}>{item.name}</Option>)}
                </Select>
            </Form.Item>
            <Form.Item name="description" label="Mô tả">
                <Input.TextArea rows={4} />
            </Form.Item>
            <Form.Item name="status" label="Kích hoạt" valuePropName="checked">
                <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
            </Form.Item>
            <Form.Item label="Ảnh sản phẩm">
                <Upload
                    action={`${getUploadApiBaseUrl()}/api/v1/uploads`}
                    name="file"
                    listType="picture-card"
                    fileList={fileList}
                    className="upload-list-inline"
                    withCredentials={true}
                    accept="image/*"
                    headers={{
                        Authorization: AccountMetaData.getToken(),
                        Company: AccountMetaData.getCompanyId()
                    }}
                    onChange={onFileChange}
                    onPreview={(file) => {
                        let url = file.url;
                        if (file.response && file.response.attachment) url = file.response.attachment.url;
                        if (url) window.open(url);
                    }}
                    multiple
                >
                    <div>
                        <PlusOutlined />
                        <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                </Upload>
            </Form.Item>
        </div>
    );
}
